import React from "react"
import { eventPlaces } from "./mainListPlaces"

const value = number => Number.isFinite(number) ? number : "—"
// The entries count every reserved WildCard place, held or not (mainListPlaces.js).
export default function EntrySummary({ totals, competitions }) {
  if (!totals) return <span className="text-muted">Entries unavailable</span>
  if (totals.competitionCount === 0) return <span className="text-muted">No competitions</span>
  const places = eventPlaces(totals, competitions)
  return <div className="event-entry-summary">
    <strong>{value(places.taken)} / {value(totals.capacity)} entries</strong>
    <small>incl. {value(places.occupied)} / {value(places.reserved)} WildCards</small>
    <small>Waiting: {value(totals.waitingList)} · Pre-entries: {value(totals.preRegistrationList)}</small>
  </div>
}
